<template>
    <b-card :title="title">

         <b-card-header >   
            <b-row>
                <b-col class="col-md-8">
                    <b-input v-model="filter" type="search" placeholder="Search transaction types..."></b-input>
                </b-col>

                <b-col >
                    <slot></slot>
                </b-col>
            </b-row>
        </b-card-header>

        <b-card-body>

            <p class="mt-3">
                Page: {{ currentPage }} of {{ Math.ceil(rows/itemsPerPage) }} Total:
                {{ rows}}
            </p>

            <b-table :fields="fields" striped hover responsive :items="items" :per-page="itemsPerPage"
      :current-page="currentPage" :filter="filter">
                <template #cell(id)="row">
                    <b-button
                        size="sm"
                        @click="$emit('show-item', row.item.id)"
                        class="mr-2"
                        variant="primary"
                    >
                        View
                    </b-button>
                </template>

                <template #cell(flow)="{ value }">
                    <span>{{ getFlowName(value) }}</span>
                </template>

                <template #cell(entity)="{ value }">
                    <span>{{ getEntityName(value) }}</span>
                </template>

                <template #cell(reference_entity)="{ value }">
                    <span>{{ getEntityName(value) }}</span>
                </template>
            </b-table>

            <b-row>
                <b-col>
                    <b-pagination
                        class="float-right"
                        v-model="currentPage"
                        :total-rows="rows"
                        :per-page="itemsPerPage"
                        aria-controls="roleTable"
                        pills
                        align="right"
                    ></b-pagination>
                </b-col>
            </b-row>

        </b-card-body>
    </b-card>
</template>
<script>
import popupMixins from '@/mixins/popupMixins'

export default {
    name: 'ListItems',
    mixins: [popupMixins],
    props: ['items', 'title'],

    data() {
        return {
            filter: '',
            itemsPerPage: 15,
            currentPage: 1,
            fields: [
                { key: 'id', label: 'Actions' },
                'name',
                'entity',
                'flow',
                { key: 'reference_entity', label: 'Reference' },
            ],
        }
    },

    mounted() {},

    computed: {
        user() {
            return this.$store.state.user
        },
        permissions() {
            return this.$store.state.rolePermissions
        },
        user_permissions() {
            return this.$store.getters.user_permissions
        },
        flowOptions() {
            return this.$store.getters['transactionType/flowOptions']
        },

        entityOptions() {
            return this.$store.getters['transactionType/entityOptions']
        },

        rows() {
            return this.items.length
        }

    },

    methods: {
        getEntityName(value) {
            if (value == -1) return 'None'
            return (this.entityOptions.find(x => x.value === value) || {}).text
        },

        getFlowName(value) {
            return (this.flowOptions.find(x => x.value === value) || {}).text
        },

        
    },
}
</script>
<style></style>
